var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row-box"},_vm._l((_vm.data),function(fieldValue,fieldName){return _c('WrapperField',{key:fieldValue + fieldName,attrs:{"data":_vm.createDataField({
        fieldName: fieldName,
        fieldValue: fieldValue,
        fieldGroup: _vm.FieldGroup.SECURITY_EVIDENCE_DETAILS,
      })}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }